import { c as _c } from "react/compiler-runtime";
import type { StandardSvgProps } from 'src/components/svg/StandardSvgProps';
import classNames from 'classnames';
import svgStyles from './SVGStyles.module.css';
export default function PosterListSvg(t0) {
  const $ = _c(10);
  const {
    className
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = classNames(svgStyles.SDefaultSvg, className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <rect width="3.713" height="6.683" rx="1" />;
    t3 = <rect width="3.713" height="6.683" rx="1" transform="translate(5.94)" />;
    t4 = <rect width="3.713" height="6.683" rx="1" transform="translate(11.88)" />;
    t5 = <rect width="3.713" height="6.683" rx="1" transform="translate(0 8.91)" />;
    t6 = <rect width="3.713" height="6.683" rx="1" transform="translate(5.94 8.91)" />;
    t7 = <rect width="3.713" height="6.683" rx="1" transform="translate(11.88 8.91)" />;
    $[2] = t2;
    $[3] = t3;
    $[4] = t4;
    $[5] = t5;
    $[6] = t6;
    $[7] = t7;
  } else {
    t2 = $[2];
    t3 = $[3];
    t4 = $[4];
    t5 = $[5];
    t6 = $[6];
    t7 = $[7];
  }
  let t8;
  if ($[8] !== t1) {
    t8 = <svg className={t1} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 15.593 15.593">{t2}{t3}{t4}{t5}{t6}{t7}</svg>;
    $[8] = t1;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  return t8;
}